import { createStructuredSelector } from 'reselect';
import {
  DP_DOCUMENTATION_LIST,
  DP_DOCUMENTATION_LIST_SUCCESS,
  DP_DOCUMENTATION_LIST_ERROR,
  DP_DOCUMENTATION_INVOICE_TEMPLATE_DATA,
  DP_DOCUMENTATION_INVOICE_TEMPLATE_DATA_SUCCESS,
  DP_DOCUMENTATION_INVOICE_TEMPLATE_DATA_ERROR,
  DP_DOCUMENTATION_SEND_INVOICE_EMAIL,
  DP_DOCUMENTATION_SEND_INVOICE_EMAIL_SUCCESS,
  DP_DOCUMENTATION_SEND_INVOICE_EMAIL_ERROR,
  DP_DOCUMENTATION_SEND_LETTERS_EMAIL,
  DP_DOCUMENTATION_SEND_LETTERS_EMAIL_SUCCESS,
  DP_DOCUMENTATION_SEND_LETTERS_EMAIL_ERROR
} from '../../actions';

export const NAME = 'delivery_plan_documentation';

export const DocumentationList = (filters) => ({
  type: DP_DOCUMENTATION_LIST,
  payload: { filters: filters || {} }
});
export const DocumentationListSuccess = (data) => ({
  type: DP_DOCUMENTATION_LIST_SUCCESS,
  payload: data
});
export const DocumentationListError = (error) => ({
  type: DP_DOCUMENTATION_LIST_ERROR,
  payload: error
});

export const DocumentationInvoiceTemplateData = (reference) => ({
  type: DP_DOCUMENTATION_INVOICE_TEMPLATE_DATA,
  payload: { v_delivery_order_reference: reference }
});
export const DocumentationInvoiceTemplateDataSuccess = (invoiceData, accessoryComplementData, supplierEmailData, sentEmailInfo) => ({
  type: DP_DOCUMENTATION_INVOICE_TEMPLATE_DATA_SUCCESS,
  payload: { invoiceData, accessoryComplementData, supplierEmailData, sentEmailInfo }
});
export const DocumentationInvoiceTemplateDataError = (error) => ({
  type: DP_DOCUMENTATION_INVOICE_TEMPLATE_DATA_ERROR,
  payload: error
});
export const DocumentationSendInvoiceEmail = (reference) => ({
  type: DP_DOCUMENTATION_SEND_INVOICE_EMAIL,
  payload: { v_delivery_order_reference: reference }
});
export const DocumentationSendInvoiceEmailSuccess = (data) => ({
  type: DP_DOCUMENTATION_SEND_INVOICE_EMAIL_SUCCESS,
  payload: data
});
export const DocumentationSendInvoiceEmailError = (error) => ({
  type: DP_DOCUMENTATION_SEND_INVOICE_EMAIL_ERROR,
  payload: error
});

export const DocumentationSendLettersEmail = (reference, letters) => ({
  type: DP_DOCUMENTATION_SEND_LETTERS_EMAIL,
  payload: { v_delivery_order_reference: reference, letters }
});
export const DocumentationSendLettersEmailSuccess = (data, reference) => ({
  type: DP_DOCUMENTATION_SEND_LETTERS_EMAIL_SUCCESS,
  payload: { ...data, reference }
});
export const DocumentationSendLettersEmailError = (error, reference) => ({
  type: DP_DOCUMENTATION_SEND_LETTERS_EMAIL_ERROR,
  payload: { error, reference }
});

const deliveryPlanDocumentation = (state) => state[NAME];
export const DeliveryPlanDocumentationSelector = createStructuredSelector({ deliveryPlanDocumentation });
